"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventEmitter = exports.CardholderQuery = exports.CardsavrHelper = void 0;
var CardsavrJSLibrary_2_0_1 = require("./CardsavrJSLibrary-2.0");
var CardsavrSessionUtilities_1 = require("./CardsavrSessionUtilities");
var CardsavrSDKError_1 = __importDefault(require("./CardsavrSDKError"));
var CardsavrRestError_1 = __importDefault(require("./CardsavrRestError"));
var CardsavrHelper = /** @class */ (function () {
    function CardsavrHelper() {
        this._sessions = {};
        this.cardsavr_server = "";
        this.app_name = "";
        this.app_key = "";
        this.reject_unauthorized = true;
        this.debug = false;
    }
    CardsavrHelper.prototype.setAppSettings = function (cardsavr_server, app_name, app_key, reject_unauthorized, cert, proxy, debug) {
        if (reject_unauthorized === void 0) { reject_unauthorized = true; }
        if (debug === void 0) { debug = false; }
        this.cardsavr_server = cardsavr_server;
        this.app_name = app_name;
        this.app_key = app_key;
        if (!app_name) {
            throw new CardsavrSDKError_1.default([], "No app_name provided.");
        }
        else if (!app_key) {
            throw new CardsavrSDKError_1.default([], "No app_key provided.");
        }
        this.cert = cert;
        this.proxy = proxy;
        this.reject_unauthorized = reject_unauthorized;
        this.debug = debug;
        return this;
    };
    CardsavrHelper.prototype.loginAndCreateSession = function (username, password, trace) {
        return __awaiter(this, void 0, void 0, function () {
            var session, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        session = this._sessions[username];
                        _a = session;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.restoreSession(username, trace)];
                    case 1:
                        _a = (session = _b.sent());
                        _b.label = 2;
                    case 2:
                        if (_a) {
                            return [2 /*return*/, session];
                        }
                        session = new CardsavrJSLibrary_2_0_1.CardsavrSession(this.cardsavr_server, this.app_key, this.app_name, this.reject_unauthorized, this.cert, this.proxy, this.debug);
                        return [4 /*yield*/, session.init(username, password, trace)];
                    case 3:
                        _b.sent();
                        this.saveSession(username, session);
                        return [2 /*return*/, session];
                }
            });
        });
    };
    CardsavrHelper.prototype.saveSession = function (username, session) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this._sessions[username] = session;
                if ((0, CardsavrSessionUtilities_1.localStorageAvailable)()) {
                    window.sessionStorage.setItem("session_v2.3.1[".concat(username, "]"), session.getSerializedSessionData());
                }
                return [2 /*return*/];
            });
        });
    };
    CardsavrHelper.prototype.getSession = function (username) {
        var session = this._sessions[username];
        if (session) {
            return session;
        }
        throw new CardsavrSDKError_1.default([], "Must login and create session before accessing session by username.");
    };
    CardsavrHelper.prototype.restoreSession = function (username, trace) {
        return __awaiter(this, void 0, void 0, function () {
            var session_cache_data, session, err_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(0, CardsavrSessionUtilities_1.localStorageAvailable)()) return [3 /*break*/, 5];
                        session_cache_data = window.sessionStorage.getItem("session_v2.3.1[".concat(username, "]"));
                        if (!session_cache_data) return [3 /*break*/, 5];
                        session = new CardsavrJSLibrary_2_0_1.CardsavrSession(this.cardsavr_server, this.app_key, this.app_name, this.reject_unauthorized, this.cert);
                        session.setTrace(username, trace);
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        session.deserializeSessionData(session_cache_data);
                        return [4 /*yield*/, session.refresh()];
                    case 2:
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        err_1 = _a.sent();
                        window.sessionStorage.clear();
                        throw err_1;
                    case 4:
                        this.saveSession(username, session);
                        return [2 /*return*/, session];
                    case 5: return [2 /*return*/, null];
                }
            });
        });
    };
    CardsavrHelper.getInstance = function () {
        if (!CardsavrHelper.instance) {
            CardsavrHelper.instance = new CardsavrHelper();
        }
        return CardsavrHelper.instance;
    };
    CardsavrHelper.prototype.createCard = function (create_card_config) {
        return __awaiter(this, void 0, void 0, function () {
            var card, agent_username, financial_institution, _a, safe_key, cardholder_data_copy, address_data_copy, card_data_copy, agent_session, headers, card_response, err_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        card = create_card_config.card, agent_username = create_card_config.agent_username, financial_institution = create_card_config.financial_institution, _a = create_card_config.safe_key, safe_key = _a === void 0 ? null : _a;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        cardholder_data_copy = __assign({}, card === null || card === void 0 ? void 0 : card.cardholder);
                        address_data_copy = __assign({}, card === null || card === void 0 ? void 0 : card.address);
                        card_data_copy = __assign({}, card);
                        if (!cardholder_data_copy.cuid) {
                            cardholder_data_copy.cuid = (0, CardsavrSessionUtilities_1.generateUniqueUsername)();
                        }
                        //set the missing settings for model
                        if (!cardholder_data_copy.first_name)
                            cardholder_data_copy.first_name = address_data_copy.first_name;
                        if (!cardholder_data_copy.last_name)
                            cardholder_data_copy.last_name = address_data_copy.last_name;
                        if (!cardholder_data_copy.name_on_card)
                            card_data_copy.name_on_card = "".concat(card_data_copy.first_name, " ").concat(card_data_copy.last_name);
                        agent_session = this.getSession(agent_username);
                        //card requires a user id
                        address_data_copy.cardholder_ref = { "cuid": cardholder_data_copy.cuid };
                        card_data_copy.address = address_data_copy;
                        card_data_copy.cardholder = cardholder_data_copy;
                        if (!card_data_copy.par) {
                            card_data_copy.par = (0, CardsavrSessionUtilities_1.generateRandomPar)(card_data_copy.pan, card_data_copy.expiration_month, card_data_copy.expiration_year, cardholder_data_copy.cuid);
                        }
                        headers = { "x-cardsavr-hydration": JSON.stringify(["cardholder"]) };
                        if (financial_institution) {
                            headers["x-cardsavr-financial-institution"] = financial_institution;
                        }
                        return [4 /*yield*/, agent_session.createCard(card_data_copy, safe_key, headers)];
                    case 2:
                        card_response = _b.sent();
                        return [2 /*return*/, card_response.body];
                    case 3:
                        err_2 = _b.sent();
                        this.handleError(err_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    CardsavrHelper.prototype.placeCardOnSiteSingleCall = function (place_card_config) {
        return __awaiter(this, void 0, void 0, function () {
            var username, job_data, _a, financial_institution, _b, safe_key, job_data_copy, cardholder, card, account, address, agent_session, headers, response, err_3;
            return __generator(this, function (_c) {
                switch (_c.label) {
                    case 0:
                        username = place_card_config.username, job_data = place_card_config.job_data, _a = place_card_config.financial_institution, financial_institution = _a === void 0 ? null : _a, _b = place_card_config.safe_key, safe_key = _b === void 0 ? null : _b;
                        job_data_copy = JSON.parse(JSON.stringify(job_data));
                        cardholder = job_data_copy.cardholder, card = job_data_copy.card, account = job_data_copy.account;
                        address = card === null || card === void 0 ? void 0 : card.address;
                        if (!cardholder) {
                            throw new CardsavrSDKError_1.default([], "Cannot create a job without a cardholder.");
                        }
                        _c.label = 1;
                    case 1:
                        _c.trys.push([1, 3, , 4]);
                        //set the missing settings for model
                        if (!cardholder.first_name && address)
                            cardholder.first_name = address.first_name;
                        if (!cardholder.last_name && address)
                            cardholder.last_name = address.last_name;
                        if (!cardholder.cuid)
                            cardholder.cuid = (0, CardsavrSessionUtilities_1.generateUniqueUsername)();
                        if (card && !card.name_on_card)
                            card.name_on_card = "".concat(cardholder.first_name, " ").concat(cardholder.last_name);
                        if (card && !card.par) {
                            card.par = (0, CardsavrSessionUtilities_1.generateRandomPar)(card.pan, card.expiration_month, card.expiration_year, cardholder.cuid);
                        }
                        account.cardholder_ref = { "cuid": cardholder.cuid };
                        if (card) {
                            card.cardholder_ref = account.cardholder_ref;
                        }
                        if (address) {
                            address.cardholder_ref = account.cardholder_ref;
                        }
                        agent_session = this.getSession(username);
                        headers = { "x-cardsavr-hydration": JSON.stringify(["cardholder", "account", "card"]) };
                        if (financial_institution) {
                            headers["x-cardsavr-financial-institution"] = financial_institution;
                        }
                        return [4 /*yield*/, agent_session.createSingleSiteJob(job_data_copy, safe_key, headers)];
                    case 2:
                        response = _c.sent();
                        return [2 /*return*/, response.body];
                    case 3:
                        err_3 = _c.sent();
                        this.handleError(err_3);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/, null];
                }
            });
        });
    };
    CardsavrHelper.prototype.crawlErrors = function (obj) {
        var _this = this;
        var ret = [];
        if (obj._errors) {
            obj._errors.map(function (error) {
                ret.push(error);
            });
        }
        Object.keys(obj).filter(function (item) {
            var _a;
            return ((_a = obj[item]) === null || _a === void 0 ? void 0 : _a._errors) !== undefined;
        }).forEach(function (hydrated) {
            ret.push(_this.crawlErrors(obj[hydrated]));
        });
        return ret;
    };
    CardsavrHelper.prototype.handleError = function (err) {
        var _this = this;
        if (err instanceof CardsavrRestError_1.default || (err.type && err.type === "CardsavrRestError")) {
            //check for error object on response
            //if it's an array, walk each element
            //also check the child elements of each object
            if (err.errors) {
                console.log("Errors returned from REST API : " + err.response.call);
                err = err.response;
                if (err.body._errors) {
                    console.log(this.crawlErrors(err.body));
                }
                else if (Array.isArray(err.body)) {
                    err.body.map(function (obj) {
                        console.log(_this.crawlErrors(obj));
                    });
                }
            }
            else if (err.response.body) {
                console.log(err.response);
                console.log("Message returned from REST API: " + err.response.body.message);
            }
        }
        else if (err instanceof CardsavrSDKError_1.default || (err.type && err.type === "CardsavrSDKError")) {
            console.log("SDK errors, exception stack below:");
            console.log(err.errors);
            console.log(err.stack);
        }
        else {
            console.log("no errors from REST API, full error below:");
            console.log(err);
        }
    };
    CardsavrHelper.prototype.lookupMerchantSite = function (username, host) {
        return __awaiter(this, void 0, void 0, function () {
            var session, sites, site;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        session = this.getSession(username);
                        return [4 /*yield*/, session.getMerchantSites({ "host": host })];
                    case 1:
                        sites = _a.sent();
                        if (!sites || !sites.body || sites.body.length === 0) {
                            return [2 /*return*/, null];
                        }
                        site = sites.body[0];
                        if (!site) {
                            return [2 /*return*/, null];
                        }
                        return [2 /*return*/, site];
                }
            });
        });
    };
    // Assumption is the card and cardholder are already created.
    CardsavrHelper.prototype.placeCardOnSites = function (place_card_config) {
        return __awaiter(this, void 0, void 0, function () {
            var username, jobs_data, _a, safe_key, session, jobs, err_4;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        username = place_card_config.username, jobs_data = place_card_config.jobs_data, _a = place_card_config.safe_key, safe_key = _a === void 0 ? null : _a;
                        session = this._sessions[username];
                        jobs = [];
                        if (!session) return [3 /*break*/, 5];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        jobs_data.forEach(function (job) {
                            var _a;
                            job.account.cardholder_id = (_a = job.account.cardholder_id) !== null && _a !== void 0 ? _a : job.cardholder_id;
                            jobs.push(job);
                        });
                        return [4 /*yield*/, session.createSingleSiteJobs(jobs, safe_key, { "x-cardsavr-hydration": JSON.stringify(["account"]) })];
                    case 2: return [2 /*return*/, _b.sent()];
                    case 3:
                        err_4 = _b.sent();
                        console.log("Exception(s) caught in placeCardOnSites");
                        this.handleError(err_4);
                        return [3 /*break*/, 4];
                    case 4: return [3 /*break*/, 6];
                    case 5: throw new CardsavrSDKError_1.default([], "No session established for: ".concat(username, ".  Need to call loginAndCreateSession?"));
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    CardsavrHelper.prototype.placeCardOnSite = function (place_card_config) {
        return __awaiter(this, void 0, void 0, function () {
            var username, job_data, _a, safe_key, account, session, site, err_5;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        username = place_card_config.username, job_data = place_card_config.job_data, _a = place_card_config.safe_key, safe_key = _a === void 0 ? undefined : _a;
                        account = place_card_config.job_data.account;
                        session = this._sessions[username];
                        if (!session) return [3 /*break*/, 7];
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 6]);
                        if (!(!account.merchant_site_id && account.site_hostname)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.lookupMerchantSite(username, account.site_hostname)];
                    case 2:
                        site = _b.sent();
                        if (site) {
                            account.merchant_site_id = site.id;
                        }
                        _b.label = 3;
                    case 3: return [4 /*yield*/, this.placeCardOnSites({ username: username, jobs_data: [job_data], safe_key: safe_key })];
                    case 4: return [2 /*return*/, _b.sent()];
                    case 5:
                        err_5 = _b.sent();
                        this.handleError(err_5);
                        return [3 /*break*/, 6];
                    case 6: return [3 /*break*/, 8];
                    case 7: throw new CardsavrSDKError_1.default([], "No session established for: ".concat(username, ".  Need to call loginAndCreateSession?"));
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    CardsavrHelper.prototype.endSession = function (username) {
        var session = this.getSession(username);
        session.end();
        delete this._sessions[username];
        if ((0, CardsavrSessionUtilities_1.localStorageAvailable)()) {
            window.sessionStorage.removeItem("session_v2.3.1[".concat(username, "]"));
        }
    };
    CardsavrHelper.prototype.postCreds = function (post_creds_config) {
        return __awaiter(this, void 0, void 0, function () {
            var username, account_link, job_id, envelope_id, _a, safe_key, session;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        username = post_creds_config.username, account_link = post_creds_config.account_link, job_id = post_creds_config.job_id, envelope_id = post_creds_config.envelope_id, _a = post_creds_config.safe_key, safe_key = _a === void 0 ? undefined : _a;
                        session = this.getSession(username);
                        return [4 /*yield*/, session.updateSingleSiteJob(job_id, { account: { account_link: account_link } }, safe_key, envelope_id ? { "x-cardsavr-envelope-id": envelope_id } : undefined)];
                    case 1: return [2 /*return*/, _b.sent()];
                }
            });
        });
    };
    CardsavrHelper.prototype.deleteAccount = function (agent_username, cardholder_id) {
        return __awaiter(this, void 0, void 0, function () {
            var session;
            return __generator(this, function (_a) {
                try {
                    session = this.getSession(agent_username);
                    if (cardholder_id > 0) {
                        session.deleteUser(cardholder_id);
                    }
                }
                catch (err) {
                    this.handleError(err);
                }
                return [2 /*return*/];
            });
        });
    };
    CardsavrHelper.prototype.createCardholderQuery = function (username, cardholder_id) {
        var session = this.getSession(username);
        return new CardholderQuery(cardholder_id, session);
    };
    return CardsavrHelper;
}());
exports.CardsavrHelper = CardsavrHelper;
var CardholderQuery = /** @class */ (function () {
    function CardholderQuery(cardholder_id, session, interval) {
        if (interval === void 0) { interval = 2000; }
        this.creds_callbacks = {};
        this.cardholder_id = cardholder_id;
        this.session = session;
        this.interval = interval;
        this.event_emitter = new EventEmitter();
    }
    CardholderQuery.prototype.resetSession = function (session) {
        this.session = session;
    };
    CardholderQuery.prototype.credsRequestHandler = function (message) {
        return __awaiter(this, void 0, void 0, function () {
            var tries, job;
            var _a, _b, _c, _d, _e;
            return __generator(this, function (_f) {
                switch (_f.label) {
                    case 0:
                        if (!(((_a = message.message) === null || _a === void 0 ? void 0 : _a.status.startsWith("PENDING")) && !message.account_link)) return [3 /*break*/, 8];
                        tries = 2;
                        _f.label = 1;
                    case 1:
                        if (!(tries-- >= 0)) return [3 /*break*/, 7];
                        return [4 /*yield*/, this.session.getSingleSiteJobs(message.job_id, {}, { "x-cardsavr-hydration": JSON.stringify(["credential_requests"]) })];
                    case 2:
                        job = _f.sent();
                        if (!job.body.credential_requests[0]) return [3 /*break*/, 3];
                        if (((_b = message.message) === null || _b === void 0 ? void 0 : _b.status.toLowerCase()) !== "pending") {
                            this.event_emitter.emit("".concat(message.job_id, ":").concat((_c = message.message) === null || _c === void 0 ? void 0 : _c.status.toLowerCase()), job.body.credential_requests[0]);
                        }
                        this.event_emitter.emit("".concat(message.job_id, ":pending"), job.body.credential_requests[0]);
                        this.event_emitter.emit("".concat(message.job_id, ":"), job.body.credential_requests[0]);
                        return [3 /*break*/, 7];
                    case 3:
                        if (!(tries == 1)) return [3 /*break*/, 5];
                        return [4 /*yield*/, new Promise(function (resolve) { return setTimeout(resolve, 2000); })];
                    case 4:
                        _f.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        this.event_emitter.emit("".concat(message.job_id, ":").concat((_d = message.message) === null || _d === void 0 ? void 0 : _d.status.toLowerCase()), { job_id: message.job_id, type: "error", error_message: "No credential requests for this job." });
                        _f.label = 6;
                    case 6: return [3 /*break*/, 1];
                    case 7: return [3 /*break*/, 9];
                    case 8:
                        if (((_e = message.message) === null || _e === void 0 ? void 0 : _e.termination_type) && this.creds_callbacks[message.job_id]) {
                            this.removeListener(message.job_id, this.creds_callbacks[message.job_id], "job_status");
                            delete this.creds_callbacks[message.job_id];
                        }
                        _f.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    CardholderQuery.prototype.addListener = function (job_id, handler, type) {
        var _this = this;
        this.event_emitter.on("".concat(job_id, ":").concat(type !== null && type !== void 0 ? type : ""), handler);
        if (!this.creds_callbacks[job_id]) {
            this.creds_callbacks[job_id] = (function (message) { return _this.credsRequestHandler(message); });
            this.addListener(job_id, this.creds_callbacks[job_id], "job_status");
        }
        if (Object.keys(this.event_emitter.callbacks).length > 0) {
            this.runProbe();
        }
    };
    CardholderQuery.prototype.removeListeners = function (job_id) {
        var _this = this;
        Object.keys(this.event_emitter.callbacks).map(function (key) {
            var _a = key.split(":"), job_id_str = _a[0], type = _a[1];
            if (job_id_str === "".concat(job_id)) {
                _this.event_emitter.callbacks[key].map(function (handler) {
                    _this.removeListener(job_id, handler, type);
                });
            }
        });
    };
    CardholderQuery.prototype.removeListener = function (job_id, handler, type) {
        this.event_emitter.remove("".concat(job_id, ":").concat(type !== null && type !== void 0 ? type : ""), handler);
        if (Object.keys(this.event_emitter.callbacks).length === 0) {
            this.stopProbe();
        }
    };
    CardholderQuery.prototype.removeAll = function () {
        this.event_emitter.removeAll();
        this.stopProbe();
    };
    CardholderQuery.prototype.stopProbe = function () {
        if (this._user_probe) {
            clearInterval(this._user_probe);
            this._user_probe = undefined;
        }
    };
    CardholderQuery.prototype.runProbe = function () {
        var _this = this;
        if (this._user_probe) {
            return;
        }
        var tries = 0;
        this._user_probe = setInterval(function () { return __awaiter(_this, void 0, void 0, function () {
            var messages, err_6;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.session.getCardholderMessages(this.cardholder_id)];
                    case 1:
                        messages = _a.sent();
                        // if there's an error, we should say so, stop the probe, and send a status message that says the message channel is no longer available.
                        tries = 0;
                        if (messages.body) {
                            messages.body.map(function (item) { return __awaiter(_this, void 0, void 0, function () {
                                return __generator(this, function (_a) {
                                    this.event_emitter.emit("".concat(item.job_id, ":").concat(item.type), item);
                                    this.event_emitter.emit("".concat(item.job_id, ":"), item);
                                    return [2 /*return*/];
                                });
                            }); });
                        }
                        return [3 /*break*/, 3];
                    case 2:
                        err_6 = _a.sent();
                        if (tries++ > 10) {
                            this.event_emitter.emitAll({ job_id: -1, type: "error", error_message: "CardSavr connection no longer available for cardholder_id: ".concat(this.cardholder_id, ".") });
                            this.removeAll();
                        }
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); }, this.interval);
    };
    return CardholderQuery;
}());
exports.CardholderQuery = CardholderQuery;
var EventEmitter = /** @class */ (function () {
    function EventEmitter() {
        this.callbacks = {};
    }
    EventEmitter.prototype.on = function (event, cb) {
        if (!this.callbacks[event])
            this.callbacks[event] = [];
        this.callbacks[event].push(cb);
        //console.log(this.callbacks);
    };
    EventEmitter.prototype.remove = function (event, cb) {
        //console.log("REMOVE: " + event);
        if (this.callbacks[event]) {
            //console.log("FOUND CALLBACKS FOR: " + event);
            this.callbacks[event] = this.callbacks[event].filter(function (item) { return item != cb; });
            if (this.callbacks[event].length === 0) {
                //console.log("DELETE: " + event);
                delete this.callbacks[event];
            }
            //console.log(this.callbacks);
        }
    };
    EventEmitter.prototype.emitAll = function (data) {
        Object.values(this.callbacks).map(function (cbs) { return cbs.forEach(function (cb) {
            return cb(data);
        }); });
    };
    EventEmitter.prototype.removeAll = function () {
        this.callbacks = {};
    };
    EventEmitter.prototype.emit = function (event, data) {
        var cbs = this.callbacks[event];
        if (cbs) {
            cbs.forEach(function (cb) {
                return cb(data);
            });
        }
    };
    return EventEmitter;
}());
exports.EventEmitter = EventEmitter;
//# sourceMappingURL=CardsavrHelper.js.map